export const getCountryIcon = (countryId) => {
  try {
    return require(`../components/shared/icons/country/${countryId}.png`);
  } catch (err) {
    return require(`../components/shared/icons/country/country-default.svg`);
  }
};
